/* eslint-disable */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MultiPoContextProvider } from './contexts/MultiplePoContext';
import BaseMultipleModal from './baseMultiPoModal';
import { modes } from '@/config/multipleModalConfig';
import { useAuth } from '@/Components/Auth/Login/auth';

const MultiPoModal = (props) => {
	const { show, data } = useSelector(
		(state) => state?.modal?.multiplePoModal
	);
	const { appConfig = {} } = useAuth();
	const { configs = {} } = appConfig || {};
	const { mode = 'order', navSelectedStore = {}, generatedPlans } = data;
	const modeConfig = modes?.[mode] || modes?.order;

	const computedInitialState = useMemo(() => {
		const baseInitialState = { ...modeConfig?.initialState };

		const orderTypeField = modeConfig?.fields?.find(
			(f) => f.id === 'orderType'
		);
		if (orderTypeField?.configOptions) {
			const configOptions = configs?.[orderTypeField.configOptions];
			baseInitialState.orderType =
				configOptions?.length > 0 ? configOptions[0] : 'CMS';
		}

		if (data?.initialState) {
			Object.assign(baseInitialState, data.initialState);
		}

		return baseInitialState;
	}, [modeConfig, configs, data]);

	return (
		<MultiPoContextProvider initialState={computedInitialState} info={data}>
			<BaseMultipleModal
				mode={modeConfig}
				openModal={show}
				modeName={mode}
				navSelectedStore={navSelectedStore}
				generatedPlans={generatedPlans}
			/>
		</MultiPoContextProvider>
	);
};
export default MultiPoModal;
